// Module
var code = "<div id=\"content\">\n    <p>상위 단어를 구름으로 나타냅니다.</p>\n</div>";
// Exports
module.exports = code;